import { Controller } from "stimulus"

export default class extends Controller {
  reset() {
    this.element.reset()  // reset form contents
    this.element.querySelectorAll("input[type=submit]").forEach(button => button.disabled = false) // reset data-disable-with
  }
}
